import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Dialog from "./Dialog";
import styled from "styled-components";
import { ProgressBar, makeStyles } from "@fluentui/react-components";

const ProgressContainer = styled.div`
  padding: 50px 0px 0px 0px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;

  align-self: stretch;
`;

const ProgressMessage = styled.div`
  white-space: pre;
  display: flex;
  justify-content: space-between;
  align-items:center;
`;

const useStyles = makeStyles({
  text: {
    fontFamily: "var(--fontFamilyBase)",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "normal",
  }
})

export default function ProgressDialogContent({
  message,
  progress,
  className
}) {
  const styles = useStyles();

  return (
    <ProgressContainer>
      <ProgressMessage>
        <span className={styles.text}>{message} </span>

        {progress && (<span>{progress}%</span>)}
      </ProgressMessage>
      {/* <ProgressBar /> */}
      <ProgressBar {...(progress && { value: progress / 100 })} />
    </ProgressContainer>
  );
}